import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices/rootReducer.js';
import { createPollingMiddleware } from '../middleware/pollingMiddleware';

const Store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(createPollingMiddleware()),
})

export default Store;